module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABW0lEQVRIid2VwUoCQRyHv501w5IMQ+0FokOexVsRi9cikC49QU8QCF4Cq0foFAZdu3kJ6VxQUNDBELGLSZARapm1ZowoFOiusU6HPtjL/He+3+x/d3Y043ITYA7YBQxgCmdUgSywBeRdwDxwBkw7FPeQC1wDloGoAFIjlH9HOlOi2xZVxMQIem6FVyiUd3BZFY/C2wTdflvJw3uFjZtk35rlEwwjl4TcMwNrti26qt1yWM70raXLGa5recv5tgGFRonTp4u+tWzlnOJbyVnAamCJcTGG2W79GP9om0zqHlYCi84CdE0QDxns3aWpt147Y1XzhZ3iAeuzMTQ0y/mWX1EPwx/Bq0+QLOzT+Gzi1T3EgwYR34Lt3KECJFFfuHP9FuUb7Z8HyF/AMNw3HwfeJU+0tso2/ck7qCr010X3gFbFiQxIAM8KAqQzIQNycqMCx0BtBGLpkK4okPsCfy9RvEKs4A0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/xjsp.png
// module id = kCII
// module chunks = 1